<template>
  <section>
    <div class="container">Sticky</div>
  </section>
</template>

<script setup></script>

<style lang="postcss" scoped></style>
